"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'project.form.title.edit': 'Edit Project',
    'project.form.title.add': 'Add Project',
    'project.form.back': 'Back',
    'project.form.color.placeholder': '#007bff',
    'project.form.icon.placeholder': 'Choose project icon',
};
